import { Button, Checkbox, DialogContentText, ListItem, Paper, TextField } from '@material-ui/core';
import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useDispatch } from 'react-redux';

import { getDataSetToRedux } from '../../../utility/getAffirmationAndCategory';
import { IReelsCategoryCreate, ReelsCategory } from '../../../interfaces/tell_me_watch/reelsCategory.types';
import { createReelsCategory } from '../../../api/api';

export default function AddReelsCategoryComponent() {
    const dispatch = useDispatch();
    const [categoryId, setCategoryId] = useState(uuidv4());
    const [categoryIndex, setCategoryIndex] = useState(0);
    const [categoryIsActive, setCategoryIsActive] = useState(false);
    const [categoryIsDefault, setCategoryIsDefault] = useState(false);
    const [categoryIsPremium, setCategoryIsPremium] = useState(false);
    const [categoryName, setCategoryName] = useState('');
    const [categoryImage, setCategoryImage] = useState('');

    const handleSave = async () => {
        console.log("SAVE CATEGORY")
        const category: IReelsCategoryCreate = {
            id: categoryId,
            image: categoryImage,
            index: categoryIndex,
            isActive: categoryIsActive,
            isPremium: categoryIsPremium,
            isDefault: categoryIsDefault,
            name: categoryName,
        }
        const response = await createReelsCategory(category);
        await getDataSetToRedux(dispatch);
        console.log(category);

        if (response.success) {
            handleClear();
            alert("Success");
        } else {
            console.log(response.message);
            alert("Error")
        }
    }
    const handleClear = () => {
        setCategoryIsActive(false);
        setCategoryIsDefault(false)
        setCategoryIsPremium(false);
        setCategoryIndex(0);
        setCategoryImage('');
        setCategoryName('');
        setCategoryId(uuidv4());
    }

    return (

        <Paper style={{ minWidth: 800, padding: 25, margin: 25, }}>
            <h2> Add a Reels Category </h2>
            <TextField
                autoFocus
                margin="dense"
                label="id"
                type="email"
                fullWidth
                value={categoryId}
            />
            <TextField
                autoFocus
                margin="dense"
                label="name"
                type="email"
                fullWidth
                value={categoryName}
                onChange={(val) => setCategoryName(val.target.value)}
            />
            <TextField
                autoFocus
                margin="dense"
                label="image"
                type="email"
                fullWidth
                value={categoryImage}
                onChange={(val) => setCategoryImage(val.target.value)}
            />
            <TextField
                autoFocus
                margin="dense"
                label="index"
                type="number"
                fullWidth
                value={categoryIndex.toString()}
                onChange={(val) => {
                    try {
                        setCategoryIndex(Number.parseInt(val.target.value))
                    } catch (error) {
                        console.log(error);
                    }
                }}
            />

            <ListItem>
                <Checkbox
                    checked={categoryIsPremium}
                    onChange={(val, checked) => setCategoryIsPremium(checked)}
                />
                is Premium: {`${categoryIsPremium}`}
            </ListItem>

            <ListItem>
                <Checkbox
                    checked={categoryIsActive}
                    onChange={(val, checked) => setCategoryIsActive(checked)}
                />
                is Active: {`${categoryIsActive}`}
            </ListItem>
            <ListItem>
                <Checkbox
                    checked={categoryIsDefault}
                    onChange={(val, checked) => setCategoryIsDefault(checked)}
                />
                is Default: {`${categoryIsDefault}`}
            </ListItem>

            <Button onClick={handleClear} color="primary">
                Clear
            </Button>

            <Button onClick={handleSave} color="primary">
                Save
            </Button>

        </Paper>
    );
}